import { DoubleRightOutlined, PlusCircleFilled } from '@ant-design/icons'
import { Form } from 'antd'
import MainLayouts from 'layouts/MainLayouts'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { Row } from 'react-bootstrap'
import _Api from 'services/Api/_Api'
import { Button_, Input_, Number_, Select_ } from 'services/Forms/FormsSatu'
import { msg } from 'services/Toastr/Notify/_Toastr'
import DataDiet from './DataDiet'
import { useLocation } from 'react-router-dom/cjs/react-router-dom'
// import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

function BuatDiet() {

    const [frm] = Form.useForm()
    const [frm2] = Form.useForm()

    const [listWaktuMakan, setlistWaktuMakan] = useState([])
    const [listDiet, setlistDiet] = useState([])
    const [jenisDietINI, setjenisDietINI] = useState("")
    const [dataJenisDiet, setdataJenisDiet] = useState([])
    const [refresh, setrefresh] = useState(false)
    const [INIJENISDIET, setINIJENISDIET] = useState();


    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);

    const jenisdiet_idd = queryParams.get("jenisdiet_id");
    const namadiett = queryParams.get("namadiet");

    // const listDiet = [
    //     { id: "1", namadiet: "DM" },
    //     { id: "2", namadiet: "DM 1" },
    // ]
    // const listWaktuMakan = [
    //     { id: "1", waktumakan: "Makan Pagi" },
    //     { id: "5", waktumakan: "Pukul 10:00" },
    //     { id: "2", waktumakan: "Makan Siang" },
    //     { id: "6", waktumakan: "Pukul 16:00" },
    //     { id: "3", waktumakan: "Makan Malam" },
    //     { id: "7", waktumakan: "Pukul 21:00" },
    // ]
    const simpanDietBaru = () => {
        const jenisdiet = frm.getFieldValue("jenisdiet")
        if (!jenisdiet || jenisdiet == undefined || jenisdiet == "") {
            msg.error("Silahkan isi nama diet")
            return
        }
        const obj = {
            jenisdiet: jenisdiet,
        }
        _Api.post("simpan-diet", obj).then(rr => {
            if (rr.data.sts == "1") {
                loadCombo()
                frm.resetFields()
                const dt = rr.data.data
                frm.setFieldsValue({ "jenisdiet_id": parseInt(dt.id) })
                changeJenisDiet(dt.id, {children : [dt.id,dt.jenisdiet]})

            }
            msg.auto(rr.data)
            // rr.data.sts == "1" && 
        })
    }

    const simpanMappingDiet = (val) => {

        var mapjenisdiet = frm2.getFieldsValue()
        // debugger

        _Api.post("simpan-mapping-diet", { ...val, mapjenisdiet: mapjenisdiet }).then(rr => {
            if (rr.data.sts == "1") {
                loadCombo()
                frm.setFieldsValue({ "nilaigizi": "", "berat": "", "urt": "" })
                setrefresh(g => !g)

                var jenisdiet_id = frm.getFieldValue("jenisdiet_id")
                // getlistDiet(jenisdiet_id)
            }
            msg.auto(rr.data)
            // rr.data.sts == "1" && 
        })
    }


    const loadCombo = () => {
        _Api.get("load-combo-buat-diet").then(rr => {
            setlistWaktuMakan(rr.data.waktumakan)
            setlistDiet(rr.data.jenisdiet)
        })
    }





    const changeJenisDiet = (e, f) => {
        setjenisDietINI(f.children[1])
        setINIJENISDIET(e)
        frm2.resetFields()

        _Api.get("get-list-diet?jenisdiet_id=" + e).then(d => {
            const dt = d.data.mapgizi
            const result = Object.fromEntries(dt.map(({ field, value }) => [field, value]));
            frm2.setFieldsValue(result)
        })

        // getlistDiet(e)
    }

    const listNilaiGizi = [
        { label: "Energi", name: "energi", sm: "2", after: "kkal" },
        { label: "Protein", name: "protein", sm: "2", after: "gr" },
        { label: "Lemak", name: "pemak", sm: "2", after: "gr" },
        { label: "Karbohidrat", name: "karbohidrat", sm: "2", after: "gr" },
        { label: "Natrium", name: "natrium", sm: "2", after: "mg" },
        { label: "Kalium", name: "kalium", sm: "2", after: "mg" },
    ]


    useEffect(() => {
        frm2.resetFields()
        loadCombo()
        setTimeout(() => {
            if (jenisdiet_idd != undefined) {
                setINIJENISDIET(jenisdiet_idd)
                setrefresh(g => !g)
                frm.setFieldsValue({ "jenisdiet_id": parseInt(jenisdiet_idd) })
                changeJenisDiet(jenisdiet_idd, {children : ["",namadiett]})
            }
        }, 300);


    }, [])

    return (
        <MainLayouts>


            <br />
            <Form form={frm} layout='vertical' onFinish={simpanMappingDiet}>
                <Row>
                    <Input_ label="Nama Diet (ketik di sini jika tidak ada di sebelah)" sm="5" name="jenisdiet" />
                    <Button_ icon={<DoubleRightOutlined />} sm="1" label=" " onClick={simpanDietBaru} block style={{ marginTop: "24px" }} />
                    <Select_ required onChange={changeJenisDiet} label="Nama Diet" sm="6" name="jenisdiet_id" caption="jenisdiet" val="id" option={listDiet} />

                </Row>
                <br />
                <h4> Pemberian Gizi </h4>
                <Form form={frm2}>
                    <Row className='bg-success p-3'>
                        {
                            listNilaiGizi.map(d =>
                                <Input_ required label={d.label} sm={d.sm} name={d.name} addonAfter={d.after} />
                            )
                        }
                    </Row>
                </Form>
                <br />
                <Row>
                    <Select_ required label="Waktu Makan" sm="3" name="waktumakan_id" caption="waktumakan" val="id" option={listWaktuMakan} />
                </Row>
                <Row className='border-bottom'>
                    <Input_ required label="Jenis Makanan" sm="5" name="nilaigizi" />
                    <Number_ required label="Porsi (pakai titik jika ada pecahan koma)" sm="3" name="berat" addonAfter="gr" />
                    <Input_ label="URT" sm="2" name="urt" />
                    <Button_ label="Simpan" style={{marginTop :"22px"}} icon={<PlusCircleFilled />} submit sm="2" block />
                </Row>
                <br />
                <div> Jenis Diet </div>
                <h1 className='bg-warning px-3'>{jenisDietINI}</h1>
                {/* <Table bordered dataSource={dataJenisDiet} columns={columns}  pagination={false}/> */}

                <DataDiet refresh={refresh} jenisdiet_id={INIJENISDIET} />


                {/* <Input_ required label="Protein  " sm="2" name="protein" addonAfter="gr" />
                <Input_ required label="Lemak  " sm="2" name="lemak" addonAfter="gr" />
                <Input_ required label="Karbohidrat " sm="2" name="karbohidrat" addonAfter="gr" />
                <Input_ required label="Natrium" sm="2" name="natrium" addonAfter="mg" />
                <Input_ required label="Kalium " sm="2" name="kalium" addonAfter="mg" /> */}


            </Form>
        </MainLayouts>
    )
}

export default BuatDiet